import { bindable, inject } from 'aurelia';

@inject(Element)
export class Callout {

    @bindable public type: string = 'danger';
    public message: string;
    constructor(element: Element) {
        this.message = element.innerHTML;
    }
}
